module.exports = __webpack_public_path__ + "static/img/help_09study_01.e3f13a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_09study_01.png
// module id = 705
// module chunks = 140